import { useProperty } from '@eti/providers';
import type { TicketsVersionProps } from '../model';
import { TicketV1 } from './ticketVersion/TicketV1';
import { TicketV2 } from './ticketVersion/TicketV2';
import { TicketV3 } from './ticketVersion/TicketV3';
import { TicketV4 } from './ticketVersion/TicketV4';
import { TicketV5 } from './ticketVersion/TicketV5';

export const Ticket = ({
  hasError,
  isLoading,
  isRyanAirTicketingOrMarketingCarrierPresent,
  isVI,
  onClick,
  onSelect,
  selectedTicketType,
  ticketVersion,
  ticketPriceModalInfo,
  tickets,
  ...props
}: TicketsVersionProps & {
  isRyanAirTicketingOrMarketingCarrierPresent: boolean;
}) => {
  const { p } = useProperty();
  const updatedTicketsOrder = p('Result.Page.Ticket.Reversed') ? tickets.reverse() : tickets;
  switch (ticketVersion) {
    case 1:
      return (
        <TicketV1
          isLoading={isLoading}
          isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
          isVI={isVI}
          onClick={onClick}
          selectedTicketType={selectedTicketType}
          ticketPriceModalInfo={ticketPriceModalInfo}
          tickets={updatedTicketsOrder}
          {...props}
        />
      );
    case 2:
      return (
        <TicketV2
          hasError={hasError}
          isVI={isVI}
          onSelect={onSelect}
          selectedTicketType={selectedTicketType}
          tickets={updatedTicketsOrder}
          {...props}
        />
      );
    case 3:
      return (
        <TicketV3
          hasError={hasError}
          isVI={isVI}
          onSelect={onSelect}
          selectedTicketType={selectedTicketType}
          tickets={updatedTicketsOrder}
          {...props}
        />
      );
    case 4:
      return (
        <TicketV4
          isLoading={isLoading}
          isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
          isVI={isVI}
          onClick={onClick}
          selectedTicketType={selectedTicketType}
          ticketPriceModalInfo={ticketPriceModalInfo}
          tickets={updatedTicketsOrder}
          {...props}
        />
      );
    case 5:
      return (
        <TicketV5
          isLoading={isLoading}
          isRyanAirTicketingOrMarketingCarrierPresent={isRyanAirTicketingOrMarketingCarrierPresent}
          isVI={isVI}
          onClick={onClick}
          selectedTicketType={selectedTicketType}
          ticketPriceModalInfo={ticketPriceModalInfo}
          tickets={updatedTicketsOrder}
          {...props}
        />
      );
    default:
      return (
        <TicketV3
          hasError={hasError}
          isVI={isVI}
          onSelect={onSelect}
          selectedTicketType={selectedTicketType}
          tickets={updatedTicketsOrder}
          {...props}
        />
      );
  }
};
